import type { ExternalTableSchema } from '@packages/table-builder';

export const grantAcceptanceTemplateTable: ExternalTableSchema = {
  metadata: {
    title: 'Grant Acceptance Template',
    entity: 'Grant Acceptance Template',
  },

  dataSource: {
    endpoint: '/api/award/api/app/grant-acceptance-template',
    method: 'GET',
    rowIdField: 'templateId',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
    confirmBeforeSave: {
      title: 'Are you sure you want to Save?',
    },
  },

  columns: [
    {
      field: 'templateName',
      header: 'Template Name',
      type: 'text',
      width: 150,
      visibility: 'locked',
      editable: { type: 'text', placeholder: 'Template name' },
    },
    {
      field: 'statusName',
      header: 'Status',
      type: 'badge',
      width: 200,
      editable: { type: 'asyncSelect' },
      dataSource: {
        url: '/api/award/api/app/grant-agreement-document-status/grant-agreement-document-status-dropdown',
        mapper: { label: 'displayName', value: 'displayName' },
      },
      badge: {
        statusMap: {
          Active: 'success',
          Inactive: 'error',
          Draft: 'info',
        },
      },
    },
    {
      field: 'noOfVersions',
      header: 'No. of Versions',
      type: 'text',
    },
  ],

  actions: {
    row: [
      { id: 'ADD_VERSION_GRANT_ACCEPTANCE_TEMPLATE', label: 'Add Version' },
      { id: 'DELETE_TEMPLATE_GRANT_ACCEPTANCE_TEMPLATE', label: 'Delete Template', variant: 'danger' },
    ],
    subRow: [
      { id: 'PREVIEW_VERSION_GRANT_ACCEPTANCE_TEMPLATE', label: 'Preview' },
      { id: 'EDIT_CONTENT_GRANT_ACCEPTANCE_TEMPLATE', label: 'Edit Content' },
      { id: 'COPY_CONTENT_GRANT_ACCEPTANCE_TEMPLATE', label: 'Copy Content' },
      { id: 'DELETE_VERSION_GRANT_ACCEPTANCE_TEMPLATE', label: 'Delete Version', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_GRANT_ACCEPTANCE_TEMPLATE',
        label: 'Add Template',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    editing: { bulkSave: true },
    rows: {
      subRows: {
        dataField: 'versions',
        expandMode: 'collapsed',
        columns: [
          { field: 'version', header: 'Version', type: 'text', width: 200 },
          { field: 'effectiveDate', header: 'Effective Date', type: 'date', editable: { type: 'date', placeholder: 'MM/DD/YYYY' } },
        ],
        actions: [
          { id: 'PREVIEW_VERSION_GRANT_ACCEPTANCE_TEMPLATE', label: 'Preview' },
          { id: 'EDIT_CONTENT_GRANT_ACCEPTANCE_TEMPLATE', label: 'Edit Content' },
          { id: 'COPY_CONTENT_GRANT_ACCEPTANCE_TEMPLATE', label: 'Copy Content' },
          { id: 'DELETE_VERSION_GRANT_ACCEPTANCE_TEMPLATE', label: 'Delete Version', variant: 'danger' },
        ],
      },
    },
  },
};
